/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import {useSelector} from 'react-redux';
import {CTCEntity} from '@ion/core/src/types/entities';

/**
 * Provides a utility hook for getting the cloned operation results for any entity via
 * its respective reducer ...
 *
 * ```typescript
 *
 *   import {useClonedResults} from '@ion/dls/src/hooks/';
 *   const useClonedResults = useClonedResults('reducer');
 *
 * ```
 */
export const useClonedResults = (reducer: string): CTCEntity | CTCEntity[] => {
  return useSelector(({[reducer]: {clone}}) => clone?.result);
};

export default useClonedResults;
